import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Card from '../Card';

const BeeName = styled.span`
  display: block;
`;

const FoodCoverage = styled.span`
  font-weight: 600;
  display: block;
`;

const ImgHolder = styled.div`
  height: 100%;
  width: 100%;
  background-image: url(${(props) => props.imageUrl});
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 5px;
`;

const SmallSubjectCard = ({
  foodCoverage, name, imagePath,
}) => (
  <Card>
    <Row>
      <Col md={5}>
        <ImgHolder imageUrl={`${process.env.REACT_APP_API_URL}${imagePath}`} />
      </Col>
      <Col className="mb-2 mt-2 pl-0" md={7}>
        <BeeName>{name}</BeeName>
        { foodCoverage !== null && (
          <FoodCoverage className="mb-1">
            {foodCoverage}
            % voedseldekking
          </FoodCoverage>
        )}
      </Col>
    </Row>
  </Card>
);

SmallSubjectCard.propTypes = {
  foodCoverage: PropTypes.number,
  name: PropTypes.string.isRequired,
  imagePath: PropTypes.string.isRequired,
};

SmallSubjectCard.defaultProps = {
  foodCoverage: null,
};

export default SmallSubjectCard;
